import { 
  DxScrolling, 
  DxPager, 
  DxPaging, 
  DxSelection, 
  DxDataGrid, 
  DxColumn,
  DxLoadPanel,
} from "devextreme-vue/data-grid"
import { getListInvoiceFromModule, getAutoListInvoiceFromModule } from '@/api/action-defines/e-invoice-management'
import {INVOICE_STATUS, INVOICE_STATUS_CODE} from "@/@core/data/enum/invoiceStatus";
import ModuleInvoiceDetail from "@/views/components/module-invoice-detail";
import { INPUT_TYPE } from "@/@core/data/enum/inputType";
import flatPickr from "vue-flatpickr-component";
import { getListModuleApi, getListSearchAndHeaderApi, getListHotelByModuleApi  } from "@/api/action-defines/e-invoice-management";
import { $GET } from "@/api/gateway/gatewayMethods";
import store from '@/store';
import router from '@/router';
import {PartnerCode} from '@core/data/enum/partnerCode';
import {EInvoiceActionCodes} from '@core/data/enum/menuCode';
export default {
  components: {
    DxSelection,
    DxDataGrid,
    DxScrolling,
    DxPager,
    DxPaging,
    DxColumn,
    DxLoadPanel,
    flatPickr,
    ModuleInvoiceDetail,
    store
  },

  data() {
    return {
      dataSource: [],
      statusList: [...INVOICE_STATUS],
      selectedInvoices: [],
      isOpen: false,
      inputSearchList: [],
      search: {},
      //Pagination
      paging: {
        PageSize: 20,
        PageIndex: 1,
      },
      totalPagination: {
        TotalRecord: 0,
        TotalPage: 0,
      },
      moduleList: [],
      configTable: [],
      currentModule: {},
      autoSelectAfterSearch: false,
      hotelList: [],
      currentHotel: {
        key: null,
        value: this.$t('hotel_name'),
      },
      isViewDetailOpen: false,

      fpConfig: {
        mode: 'range',
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'd/m/Y',
        locale: { rangeSeparator: ' -> ' },
        defaultDate: []
      },
      partnerInfo: {},
      autoOpenWhenModuleToInvoice: true,
    }
  },
  async created() {
    await this.getAllModule();

    // Module có thể do bên ngoài chỉ định (query param moduleId/moduleCode), không có thì mặc định module đầu tiên
    this.currentModule = this.resolveInitialModule();
    this.$store.commit('eInvoiceManagement/setModuleId', this.currentModule ? this.currentModule.key : null);
    // Nạp danh sách khách sạn SONG SONG với cấu hình search-bar (chỉ cần currentModule.key, không phụ thuộc
    // nhau) và giữ promise (không reactive) để luồng redirect dùng lại. Phải kích hoạt TRƯỚC await bên dưới:
    // textbox "Booking Code" được mount (và bắn moduleToEInvoiceGetSearchParamFill) ngay trong cùng lượt
    // microtask với lúc created() resume sau getHeadersAndColumns, nên gán sau đó là quá muộn.
    this.hotelListPromise = this.getListHotelByModule();
    await this.getHeadersAndColumns(this.currentModule ? this.currentModule.Id : null);
    await this.hotelListPromise;
    this.inputSearchList.map(ip => {
      this.search[ip.FieldKey] = null;
    })
  },
  mounted() {
    const t = new Date();
    const today = new Date(t.getFullYear(), t.getMonth(), t.getDate(), 0, 0, 0, 0);
    const toExclusiveLocal = new Date(t.getFullYear(), t.getMonth(), t.getDate() + 1, 0, 0, 0, 0);
    this.fpConfig.defaultDate = [today, today];
    this.search.fromDate = today.toISOString();
    this.search.toDateExclusive = toExclusiveLocal.toISOString();
    this.dedupeData();

    this.$nextTick(() => {
      const fp = this.$refs.dateRangePicker?.fp;
      if (fp && fp.selectedDates?.length === 2) {
        this.changeDateRange(fp.selectedDates, fp.input.value, fp);
      }
    });
  },
  watch: {
    // Nếu cần tự động search khi prop reservationNumber đổi
    reservationNumber(newVal) {
      if (this.isOpen && newVal) {
        this.searchModuleInvoice();
      }
    }
  },
  methods: {
    addFooter(value) {
      this.isViewDetailOpen = value;
    },
    onContentReady(e) {
      e.component.option('loadPanel.enabled', false);
      console.log("this.$store.state.autoSelectAfterSearch:: :: ", this.$store.state.eInvoiceManagement.autoSelectAfterSearch)
      if (this.$store.state.eInvoiceManagement.autoSelectAfterSearch) {
        e.component.selectAll();
        this.$store.commit('eInvoiceManagement/setAutoSelectAfterSearch', false);
      }

      
    },

    onUpdateSelectedRowKeys(val) {
      const arr = Array.isArray(val) ? val : [];
      const seen = new Set();
      const clean = [];

      for (const k of arr) {
        if (!k || !k.InvoiceId || k.InvoiceNo == null) continue;
        const sig = `${k.InvoiceId}|${String(k.InvoiceNo)}`;
        if (seen.has(sig)) continue;
        seen.add(sig);
        clean.push({ InvoiceId: k.InvoiceId, InvoiceNo: String(k.InvoiceNo), ReservationRoomId: k.ReservationRoomId });
      }

      this.selectedInvoices = clean;
    },
    onSelectionChanged(e) {
      this.onUpdateSelectedRowKeys(e.selectedRowKeys);
      this.$nextTick(() => {
        const grid = this.$refs.dataGridRef && this.$refs.dataGridRef.instance;
        if (grid) {
          const view = grid.element().querySelector('.dx-datagrid-rowsview');
          view && view.blur && view.blur();
        }
      });
    },

    async handleClickModuleOption(option) {
      this.currentModule = option;
      this.$store.commit('eInvoiceManagement/setModuleId', this.currentModule ? this.currentModule.key : null);

      // Bỏ chọn khách sạn nằm TRONG getListHotelByModule: đổi module mà module mới chỉ có 1 khách sạn thì
      // nó tự điền, xóa lại ở đây là làm mất đúng cái vừa điền.
      await this.getListHotelByModule();
    },

    handleClickHotelOption(option) {
      this.currentHotel = option;
    },

    searchInvoice() {

    },

    openInvoiceDetail(data) {
      const ezInvoiceId = data.EInvoiceId;
      function openEInvoiceInNewTab(ezInvoiceId) {
        const resolved = router.resolve({
          path: '/e-invoice',
          query: { ezInvoiceId }
        })
        // mở tab mới
        window.open(resolved.href, '_blank', 'noopener,noreferrer')
      }
      const { MINVOICE, CYBER_BILL , VIETTEL, VNPT, SUN, MISA} = PartnerCode;
      const { DRAFT, ORIGINAL, ADJUSTMENT, REPLACEMENT } = INVOICE_STATUS_CODE;

      if ([MINVOICE, CYBER_BILL].includes(this.partnerInfo.PartnerCode)
          && ([DRAFT].includes(this.EinvoiceDetailData.StatusEInvoice)
              || ([DRAFT, ORIGINAL, ADJUSTMENT, REPLACEMENT].includes(this.EinvoiceDetailData.StatusEInvoice) && !this.EinvoiceDetailData.StatusSign))
          && this.$lsAllowOperation(EInvoiceActionCodes.EDIT)
      ){
        openEInvoiceInNewTab(ezInvoiceId);
      }else if ([VIETTEL, VNPT, SUN, MISA].includes(this.partnerInfo.PartnerCode)
          && [DRAFT].includes(this.EinvoiceDetailData.StatusEInvoice)
          && this.$lsAllowOperation(EInvoiceActionCodes.EDIT)
      ){
        openEInvoiceInNewTab(ezInvoiceId);
      }else {
        openEInvoiceInNewTab(ezInvoiceId);
      }
    },

    changeDateRange(selectedDates, dateStr, instance) {
      if (!selectedDates || selectedDates.length < 2) {
        this.search.fromDate = null;
        this.search.toDateExclusive = null;
        this.search.toDateInclusive = null;
        return;
      }
      const [start, end] = selectedDates;

      // 00:00 local
      const fromLocal = new Date(
          start.getFullYear(), start.getMonth(), start.getDate(), 0, 0, 0, 0
      );

      // 00:00 ngày hôm sau local, dùng half open interval [from, to)
      const toExclusiveLocal = new Date(
          end.getFullYear(), end.getMonth(), end.getDate() + 1, 0, 0, 0, 0
      );

      // nếu BE nhận UTC ISO, convert sang ISO Z
      this.search.fromDate = fromLocal.toISOString();
      this.search.toDateExclusive = toExclusiveLocal.toISOString();

      // nếu BE hoặc UI cần inclusive 23:59:59.999
      const toInclusiveLocal = new Date(toExclusiveLocal.getTime() - 1);
      this.search.toDateInclusive = toInclusiveLocal.toISOString();
    },

    // Module khởi tạo: ưu tiên module do bên gọi truyền sang, không khớp thì fallback module đầu tiên như cũ
    resolveInitialModule() {
      // {} chứ không phải undefined: header còn render `currentModule.value` trực tiếp.
      const fallback = this.moduleList[0] || {};
      if (!this.moduleList.length) return fallback;

      const params = new URLSearchParams(window.location.search);
      const moduleId = params.get('moduleId');
      const moduleCode = params.get('moduleCode') || params.get('module');

      if (moduleId) {
        const byId = this.moduleList.find(
          m => m.key != null && String(m.key).toLowerCase() === String(moduleId).trim().toLowerCase()
        );
        if (byId) return byId;
      }

      if (moduleCode) {
        const byCode = this.moduleList.find(
          m => m.code != null && String(m.code).toLowerCase() === String(moduleCode).trim().toLowerCase()
        );
        if (byCode) return byCode;
      }

      if (moduleId || moduleCode) {
        console.warn('Module không khớp, dùng module mặc định:', { moduleId, moduleCode });
      }

      return fallback;
    },

    async getAllModule() {
      await getListModuleApi()
        .then((res) => {
          if(res.StatusCode == 200) {
            this.moduleList = res.Data.map(el => {
              return {
                key: el.Id,
                value: el.Name,
                code: el.Code,
              }
            })
          }
        })
    },

    async getListHotelByModule() {
      if (!this.currentModule || this.currentModule.key == null) {
        this.hotelList = [];
        this.resetHotelSelection();

        return;
      }

      const BodyData = {
        ModuleId: this.currentModule.key,
      }

      try {
        const res = await getListHotelByModuleApi({BodyData : BodyData})

        this.hotelList = res && res.StatusCode == 200 && res.Data && Array.isArray(res.Data.HotelList)
          ? res.Data.HotelList.map(el => {
              return {
                key: el.HotelId,
                value: el.HotelName
              }
            })
          : [];
      } catch (err) {
        // Module chưa kết nối site đang đăng nhập (BE ném 404 token_not_found) hoặc module lỗi: phải để
        // danh sách RỖNG, không giữ khách sạn của module trước — tìm kiếm tiếp là tìm sai module.
        console.warn('[module-invoice] Không lấy được danh sách khách sạn của module:', err);
        this.hotelList = [];
      }

      // Đúng một khách sạn thì tự điền luôn: màn Điều chỉnh/Thay thế không đi qua URL redirect của PMS nên
      // không có hotelId để auto-fill, người dùng thấy ô khách sạn còn placeholder và tưởng chưa chọn được.
      if (this.hotelList.length === 1) {
        this.currentHotel = { key: this.hotelList[0].key, value: this.hotelList[0].value };

        return;
      }

      // Khách sạn đang chọn không thuộc module hiện tại ⇒ bỏ chọn, tránh tìm kiếm bằng id của module khác.
      if (!this.hotelList.some(hotel => hotel && hotel.key === this.currentHotel.key)) {
        this.resetHotelSelection();
      }
    },

    resetHotelSelection() {
      this.currentHotel = { key: null, value: this.$t('hotel_name') };
    },

    async getHeadersAndColumns(moduleId) {
      console.log("Fetching headers and columns for module:", moduleId);
      const QueryParameters = {
        module: moduleId,
      }
      await getListSearchAndHeaderApi({QueryParameters})
        .then((res) => {
          if(res.StatusCode == 200) {
            // Set Header
            this.configTable = res.Data.Header.map(col => {
              col.ColumnConfig.caption = this.$t(col.ColumnConfig.caption);
              return {
                ...col.ColumnConfig
              }
            });

            // Set Search
            this.inputSearchList = res.Data.Searches.map(async (e) => {
              let fieldValueRes = null;
              if(e.ApiRoute && e.FieldFormatType === 'MultiSelectbox') {
                fieldValueRes = await $GET({ EndPoint: e.ApiRoute, QueryParameters: null})
              }

              const fieldValue = fieldValueRes?.Data.map((e) => {
                return {
                  value: e.Key,
                  text: e.Value,
                }
              })

              return {
                ...e,
                FieldValue: fieldValue,
              }
            })
            Promise.all(this.inputSearchList)
              .then((value) => {
                this.inputSearchList = value;
            })

          }
        })
        .catch((err) => {
          console.log(err);
        })
    },

    async searchModuleInvoice() {
      const BodyData = {
        ModuleId: this.currentModule ? this.currentModule.key : null,
        HotelId: this.currentHotel.key,
        InvoiceCode: this.search['InvoiceNo'] || null,
        BookingCode: this.search['Booking Code'] || null,
        FromDate: this.search.fromDate,
        ToDate: this.search.toDateExclusive,
        PageIndex: this.paging.PageIndex,
        PageSize: this.paging.PageSize,
      };

      try {
        const res = await getListInvoiceFromModule({ BodyData });
    
        if (res.StatusCode == 200) {
          
          this.dataSource = [...(res.Data.InvoiceList || [])];
          this.totalPagination.TotalRecord = res.Data.Total || 0;
          this.totalPagination.TotalPage = Math.ceil(
            this.totalPagination.TotalRecord / this.paging.PageSize,
          );
          this.$nextTick(() => {
            if (this.$refs.dataGridRef && this.$refs.dataGridRef.instance) {
              this.$refs.dataGridRef.instance.repaintRows();
            }
          });
        }
      } catch (err) {
        console.error('Lỗi gọi API:', err);
        this.$bvToast.toast('Không thể tìm kiếm hóa đơn', {
          title: 'Lỗi',
          variant: 'danger',
          solid: true
        });
      }
    },
    async autoSearchModuleInvoice(reservationRoomIds, hotelId) {
      const BodyData = {
        ModuleId: this.currentModule ? this.currentModule.key : null,
        HotelId: hotelId,
        InvoiceCode: reservationRoomIds,
        BookingCode: null,
        PageIndex: this.paging.PageIndex,
        PageSize: this.paging.PageSize,
      };
    
      try {
        const res = await getAutoListInvoiceFromModule({ BodyData });
    
        if (res.StatusCode == 200) {
          if (res.Data.Total === 0){
          }
          this.dataSource = [...(res.Data.InvoiceList || [])];
          this.totalPagination.TotalRecord = res.Data.Total || 0;
          this.totalPagination.TotalPage = Math.ceil(
            this.totalPagination.TotalRecord / this.paging.PageSize,
          );
          this.$nextTick(() => {
            if (this.$refs.dataGridRef && this.$refs.dataGridRef.instance) {
              this.$refs.dataGridRef.instance.repaintRows();
            }
          });
        }
      } catch (err) {
        console.error('Lỗi gọi API:', err);
        this.$bvToast.toast('Không thể tìm kiếm hóa đơn', {
          title: 'Lỗi',
          variant: 'danger',
          solid: true
        });
      }
    },
    
    formatNumber(number) {
      return new Intl.NumberFormat('de-US').format(number);
    },

    showInvoiceDetail() {
      this.isViewDetailOpen = true;
      this.$refs.moduleInvoiceDetail.isOpen = true;
    },

    changePage(paging) {
      this.paging = paging;
      this.searchModuleInvoice();
    },

    getInvoiceStatusUI(statusId) {
      if(!this.statusList) return
     
      const status =  this.statusList.find(s => s.id === statusId)

      if(!status) return
      
      return {
        ...status,
        text: this.$t(status.text)
      }
    },
    dedupeData() {
      const seen = new Set();
      this.dataSource = (this.dataSource || []).filter(x => {
        const k = x && x.InvoiceId;
        if (!k || seen.has(k)) return false;
        seen.add(k);
        return true;
      });
    },
    async moduleToEInvoiceGetSearchParamFill(data) {
      let isRedirected = sessionStorage.getItem('isRedirected');
      if (isRedirected === "true"){
        if (data !== 'Booking Code') return;
        const params = new URLSearchParams(window.location.search);
        let reservationIds = params.get('reservationIds');
        let hotelId = params.get('hotelId');
        let reservationRoomIds = params.get('reservationRoomIds');
        if (!reservationIds || !hotelId || !reservationRoomIds){
          sessionStorage.setItem('isRedirected', 'false'); 
          return;
        }
        // Dùng lại request khách sạn đang chạy từ created()/handleClickModuleOption (thường CHƯA trả về ở
        // thời điểm này) thay vì gọi API lần 2; chỉ gọi mới khi vì lý do nào đó chưa có request nào.
        // getListHotelByModule() đã tự .catch nên promise luôn resolve.
        const ensureHotelList = this.hotelListPromise || this.getListHotelByModule();
        await ensureHotelList.then(() => {
          let hotel = this.hotelList.find(h => h && h.key != null && h.key.toString() === hotelId.toString());

          // Luồng redirect KHÔNG cần dropdown: hotelId trên URL chính là khóa mà API tìm kiếm nhận.
          // Với module EZONE, danh sách khách sạn của BE hiện trả hardcode 1 phần tử nên find luôn trượt ở
          // các khách sạn khác ⇒ trước đây chặn luôn, không khách sạn nào ngoài 100001 xuất tùy chỉnh được.
          // Chỉ nới cho EZONE; module cũ giữ nguyên hành vi báo lỗi.
          let isEzOneModule = this.currentModule && this.currentModule.code != null
            && String(this.currentModule.code).toUpperCase() === 'EZONE';
          let searchHotelId = hotel ? hotel.key : (isEzOneModule ? hotelId : null);

          if (searchHotelId != null) {
            if (!hotel) {
              console.warn('[module-invoice] hotelId ' + hotelId + ' không có trong danh sách, dùng trực tiếp id trên URL.');
            }

            // AUTO ĐIỀN tên khách sạn vào dropdown: luồng redirect trước đây chỉ dùng id để tìm kiếm nên ô khách
            // sạn vẫn là placeholder, người dùng tưởng chưa chọn (và bấm tìm kiếm tay thì mất luôn phạm vi).
            this.currentHotel = hotel
              ? { key: hotel.key, value: hotel.value }
              : { key: searchHotelId, value: String(searchHotelId) };

            this.autoSearchModuleInvoice(reservationRoomIds, searchHotelId).then(() => {
                this.$refs.dataGridRef.instance.selectAll().then(() => {
                  this.isViewDetailOpen = true;
                  this.$refs.moduleInvoiceDetail.isOpen = true;
                });

            })
            .catch((err) => {
              sessionStorage.setItem('isRedirected', 'false');
            });

          }else{
            sessionStorage.setItem('isRedirected', 'false');
            this.$toast.error('HOTEL_NOT_FOUND');
          }

        })
        .catch((err) => {
          sessionStorage.setItem('isRedirected', 'false');
        });
      }
      
    },
  },
  computed: {
    displayTable() {
      return this.dataSource.length > 0;
    },
    isDisableViewDetail() {
      return this.selectedInvoices.length <= 0;
    },
    inputList() {
      return {
        ...INPUT_TYPE
      }
    },
    // configTable() {
    //   return [
    //     {
    //       caption: this.$t('e_invoice_management_invoice_number'),
    //       field: 'InvoiceNo',
    //       isShow: true,
    //       alignment: 'left',
    //       cellTemplate: 'invoice-number-cell',
    //       width: '8%',
    //       cellType: 'code'
    //     },
    //     {
    //       caption: this.$t('common_booking_code'),
    //       field: 'BookingCode',
    //       isShow: true,
    //       alignment: 'left',
    //       cellTemplate: 'booking-code-cell',
    //       width: '8%',
    //       cellType: 'code'
    //     },
    //     {
    //       caption: this.$t('common_total'),
    //       field: 'Total',
    //       isShow: true,
    //       alignment: 'right',
    //       cellTemplate: 'invoice-total-cell',
    //       width: '10%',
    //       cellType: 'money'
    //     },
    //     {
    //       caption: this.$t('common_e_invoice'),
    //       field: 'EInvoice',
    //       isShow: true,
    //       alignment: 'left',
    //       cellTemplate: 'e-invoice-cell',
    //       width: '20%',
    //       cellType: 'ref'
    //     },
    //   ];
    // },
    dataGrid() {
      return this.$refs['dataGridRef'].instance;
    },
  },

}